/* eslint-disable no-console */
<template>
  <div class="index">
    <Header></Header>
    <div class="content">
      <div class="left">
        <div class="top">
          <!-- <div class="topleft">       
           <div class="tableWraper cornerWraper">
              <PartHeader :title="'用户活跃统计'"></PartHeader>          
              <table class="table">
                  <tr class="th">
                    <td class="td" style="width: 40%">乡镇/街道</td>
                    <td class="td" style="width: 35%">姓名</td>
                    <td class="td" style="width: 25%">呼叫次数</td>
                  </tr>
                  <tr class="tr" v-for="item in userAct" :key="item.id">
                    <td class="td" style="width: 40%">{{item.name}}</td>
                    <td class="td" style="width: 35%">{{item.uname}}</td>
                    <td class="td" style="width: 25%">{{item.count}}</td>
                  </tr>             
              </table>
            </div>                 
             <div class="canvas cornerWraper">
              <PartHeader :title="'活跃区域TOP6'"></PartHeader>   
              <Bar :areaAct="areaAct"></Bar>             
            </div> 
          </div>-->
          <div class="topright cornerWraper">
            <!-- 实时情况 -->
              <PartHeader :title="'实时情况'"></PartHeader>   
              <MapTotal :mapTotalData="mapTotalData" totalName="东营区总用户量"></MapTotal>
              <DongyingMap :left="'2%'" :mapdata="mapdata"></DongyingMap>            
          </div>
        </div>
        <!-- 乡镇/街道报抽汇总柱状图 -->
        <div class="bottom cornerWraper">
            <PartHeader :title="'实时情况'">
              <div class="legend">
                <!-- <div class="value value1">未抽</div> -->
                <div class="value value2">全部抽数</div>
                <!-- <div class="value value3">过期</div> -->
              </div>
            </PartHeader>   
            <Bar3 :areaBar="areaBar"></Bar3>          
        </div>
      </div>
      <div class="right">
        <div class="top">
          <div class="righttop cornerWraper">
            <PartHeader :title="'乡镇/街道报抽统计'"></PartHeader>
            <Order :orderType="'chou'" @dateChange="getOrderList" :order="chouList"></Order>
          </div>
          <div class="rightmiddle cornerWraper">
            <PartHeader :title="'乡镇/街道报修统计'"></PartHeader>    
            <Order :orderType="'xiu'" @dateChange="getOrderList" :order="xiuList"></Order>        
          </div>
        </div>
        <div class="rightbottom cornerWraper">
          <PartHeader :title="'满意度'">
              <!-- <div class="legend">
                <div class="value value2">订单量</div>
                <div class="value value4">活跃度</div>
              </div>             -->
          </PartHeader>
          <div class="pieWraper">
            <Bar4 :stars="stars"></Bar4>
            <!-- <Pie :title="'优秀家庭'" :subtitle="goodFamilyName" :index="1" :piedata="goodFamily"></Pie>
            <Pie :title="'优秀村庄'" :subtitle="goodCountryName" :index="2" :piedata="goodCountry"></Pie>
            <Pie :title="'优秀乡镇/社区'" :subtitle="goodTownName" :index="3" :piedata="goodTown"></Pie> -->
          </div>
        </div>      
      </div>
    </div>
  </div>
</template>

<script>

import PartHeader from '../components/partHeader'
import Header from '../components/Header';
// import Bar from '../components/bar';
import DongyingMap from '../components/map';
import Bar3 from '../components/bar3';
import Bar4 from '../components/bar4';
import Order from '../components/order';
// import Pie from '../components/pie';
import MapTotal from '../components/mapTotal';
var moment = require('moment');

export default {
  components: {
    PartHeader,
    Header,
    // Bar,
    DongyingMap,
    Bar3,
    Bar4,
    Order,
    // Pie,
    MapTotal
  },
  data() {
    return {
      mapTotalData: {
        order_sum: '',
        order_today: '',
        user_sum: '',
        percent: ''        
      },
      mapdata: [],
      userAct: [],
      areaAct: [],
      areaBar: [],
      goodFamily: [],
      goodCountry: [],
      goodTown: [],
      goodFamilyName: '',
      goodCountryName: '',
      goodTownName: '',
      xiuList: [],
      chouList: [],
      stars: {},
    }
  },
  methods: {
    getMapDates() {
      this.$fetch('/api/town/map').then(res => {
        let data = res.data.data;
        this.mapTotalData.order_sum = data.order_sum;
        this.mapTotalData.order_today = data.order_today;
        this.mapTotalData.user_sum = data.user_sum;
        this.mapTotalData.percent = data.percent;
        let areas = data.areas;
        let mapdata = [];
        areas.forEach(item => {
          mapdata.push({
            name: item.name,
            value: [item.jing, item.wei, item.count ? item.count : 0],
          })
        });
        this.mapdata = mapdata;
      })
    },
    // 活跃用户统计
    getUserAct() {
      this.$fetch('/api/town/userAct').then(res => {
        this.userAct = res.data.data;
      })
    },
    // 活跃区域top6
    getAreaAct() {
      this.$fetch('/api/town/areaAct').then(res => {
        this.areaAct = res.data.data.map(item => {
          return {
            name: item.name,
            value: item.count,
          }
        });
      })
    },  
    // 实时统计 
    getTotalBar() {
      this.$fetch('/api/town/areaBar').then(res => {
        this.areaBar = res.data.data.map(item => {
          return {
            name: item.name,
            value: Number(item.weichou) + Number(item.yichou),
            // value1: item.yichou,
            // value2: item.guoqi,
          }
        })
      })      
    },
    // 优化单位
    getGoodUnit() {
      this.$fetch('/api/town/good').then(res => {
         let data = res.data.data;
         this.goodFamilyName = data.good_fname;
         this.goodCountryName = data.good_cname;
         this.goodTownName = data.good_tname;
         this.goodFamily = [{
            value: data.good_forder,
            name: '订单量'
         }, {
            value: data.good_fact,
            name: '活跃度'
         }];
         this.goodCountry = [{
            value: data.good_corder,
            name: '订单量'
         }, {
            value: data.good_cact,
            name: '活跃度'
         }];
         this.goodTown = [{
            value: data.good_torder,
            name: '订单量'
         }, {
            value: data.good_tact,
            name: '活跃度'
         }];                  
      })
    },
    // 按时间统计
    getOrderList(orderType, type, i) {
      let fromdate = '';
      let todate = '';
      let year = new Date().getFullYear();
      
      let beginmonth = '';
      let endmonth = '';
     
      // month
      if(type == 2 ) {
        beginmonth = i - 1;
        endmonth = i;  
      }
      // season
      if(type == 3) {
        beginmonth = (i - 1 ) * 3 + 1;
        endmonth = i * 3;
      }
      // year
      if(type == 4) {
        year = i;
        beginmonth = 0;
        endmonth = 12;
      }
      // eslint-disable-next-line no-console
      console.log(year, beginmonth, endmonth)
      fromdate = new Date(year, beginmonth);
      todate = new Date(year, endmonth);
      fromdate = moment(fromdate).format('YYYY-MM-DD hh:mm:ss');
      todate = moment(todate).format('YYYY-MM-DD hh:mm:ss');
      if(orderType == 'chou') {
          this.chouList = [];
          this.$fetch('/api/town/baochou', {
            method: 'POST',
            params: {
              type: type,
              from: fromdate,
              to: todate,
            }
          }).then(res => {
            this.chouList = res.data.data;
          })
      }
      if(orderType == 'xiu') {
          this.xiuList = [];
          this.$fetch('/api/town/baoxiu', {
            method: 'POST',
            params: {
              type: type,
              from: fromdate,
              to: todate,
            }
          }).then(res => {
            this.xiuList = res.data.data;
          })
      }
    },
    // 星级统计
    getStars() {
      this.$fetch('/api/county/star').then(res => {
         let data = res.data.data;
         this.stars = data;
      })
    },
  },
  mounted() {
    this.getMapDates();
    this.getUserAct();
    this.getAreaAct();
    this.getTotalBar();
    // this.getGoodUnit();
    this.getOrderList('chou', 1);
    this.getOrderList('xiu', 1);
    this.getStars();
  },
}
</script>

<style>
.index .table .td.active {
  color: red;
}
</style>
<style scoped>
@import './layout.css';
@import './table.css';
.content .top .topright {
  width: calc(100% - 10px);
}
.content .right .top {
   height: calc(65% - 10px);
}

.pieWraper {
  height: calc(100% - 42px);
  display: flex;
}
</style>